module.exports = __webpack_public_path__ + "static/gallery_wild_6-561206e5975fbae01d12a03124d7099a.jpg";